/**
 * Per-device toggle for whether opening Settings requires the family PIN.
 * Stored in localStorage so the preference sticks on that device only.
 * Default = ON (require PIN) — safest for shared iPads.
 */
const KEY = "ff_settings_pin_required";

export function getSettingsPinRequired() {
  try {
    const v = localStorage.getItem(KEY);
    // Default: required (true). Explicit "false" means the user opted out.
    return v !== "false";
  } catch {
    return true;
  }
}

export function setSettingsPinRequired(required) {
  try {
    if (required) localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, "false");
  } catch {
    /* ignore */
  }
}
